import { vfClassName } from './elements';
import { isNodeList, getType, getErrorElement, getGroupProp } from './functions';



/**
*** 指定された要素の各パラメータを取得する
*** @param {*} formElements[name]
*** @returns object
**/


export const getParameters = ( target ) => {

  // 要素がない、ノードリストではない、要素がボタンのときは何もしない
  if( !target || !isNodeList(target) && getType(target) === 'button' ) return;

  // NodeList だとエラーが出るので HTMLCollection に置き換える
  const element = isNodeList(target) ? target[0] : target;

  // 親要素の取得
  const parent = element.closest( vfClassName.parent ) ? element.closest( vfClassName.parent ) : null;

  // エラーメッセージを表示する要素の取得
  const errorElement = getErrorElement( element.name, Parameters.group );

  // 小見出し（label）要素の取得のために祖先要素を取得する
  const elemLabel = element.closest( vfClassName.subtitleParent ),
        tag       = elemLabel ? elemLabel.querySelector( vfClassName.subtitle ) : null;

  // エラーメッセージを表示する要素のスクロールトップを取得
  const rect      = errorElement ? errorElement.getBoundingClientRect() : null, // 要素に高さがないと 0 を返す
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // チェックボックスの value & text, 添付ファイルの容れ物
  let arrValue = [],
      arrText = [],
      arrFilesName = [],
      arrFilesSize = [],
      arrFilesType = [];



  // 各パラメータを格納するオブジェクト
  const params = {
    name     : null,
    value    : null,
    type     : null,
    title    : (parent) ? parent.querySelector(vfClassName.title).textContent : null,
    subtitle : (tag) ? tag.textContent : null,
    group    : null,
    text     : null,
    display  : ( ! element.offsetHeight && ! element.hidden) || element.disabled ? 'none' : 'block',
    dupli    : element.dataset.dupli !== undefined ? true : null,
    required : null,
    fileType : null,
    fileSize : null,
    scroll   : errorElement ? rect.top + scrollTop : null
  };



  // 複数あるチェックボックスかラジオボタン
  if( isNodeList(target) ){

    for( const item of target ){

      params.name  = item.name;

      // ラジオボタン
      if( item.type === 'radio' ){
        if( item.checked ){
          params.value = item.value;
          params.text = document.querySelector(`[for="${item.getAttribute('id')}"]`).textContent;
          //break;
        }
      }
      // チェックボックス
      if( item.type === 'checkbox' ){
        if( item.checked ){
          arrValue.push( item.value );
          arrText.push( document.querySelector(`[for="${item.getAttribute('id')}"]`).textContent );
        }
        params.value = arrValue.join(',');
        params.text = arrText.join(',');
      }
    }

  }
  else {

    params.name  = target.name;

    // ラジオボタン
    if( target.type === 'radio' || target.type === 'checkbox' ){
      params.value = target.checked ? target.value : null;
      params.text = target.checked ? document.querySelector(`[for="${target.getAttribute('id')}"]`).textContent : null;
    }
    // セレクトボックス
    else if( target.type === 'select-one' ){
      const index = target.selectedIndex;
      // disabled 属性が false のものだけ取得
      if( target[index].disabled === false ){
        params.value = target[index].value;
        params.text = target[index].textContent;
      }
    }
    else {

      // type = 'file'
      if( target.type === 'file' && target.value ){
        for( const file of target.files ){
          arrFilesName.push(file.name);
          arrFilesSize.push(file.size);
          arrFilesType.push(file.type);
        }
        params.value    = arrFilesName.join(',');
        params.fileSize = arrFilesSize.join(',');
        params.fileType = arrFilesType.join(',');
      }
      else {
        params.value = target.value ? target.value : null;
      };
    };
  };

  // 全項目共通
  params.type  = isNodeList(target) ? target[0].type : target.type; // タイプ
  params.group = getGroupProp( Parameters.group, target.name ); // グループに属しているか


//console.log(params)
  return params;

}
